<template>
  <div class="grid-service">
    <div class="banner">
      <img src="@/assets/index/convenienceServe/dp-sy-wg.png" alt />
    </div>
    <div class="self-msg">
      <p>请确认您的信息</p>
      <p>姓名: {{msg.name}}</p>
      <p>电话: {{msg.phone}}</p>
      <p>社区: {{msg.partyBrach}}</p>
      <p>
        地址:
        <el-input placeholder="请输入地址" v-model="msg.adress" clearable :disabled="alreadey"></el-input>
      </p>
    </div>

    <div class="select">
      <el-select v-model="select" clearable placeholder="请选择" :disabled="alreadey">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>

    <div class="things">
      <button v-if="buttons" @click="submit">立即提交</button>
      <div v-if="!buttons">
        <p>----办理进度----</p>
        <el-steps :active="rate.active" align-center>
          <el-step title="等待" :description="rate.description1" ></el-step>
          <el-step title="网格员已接单" :phone="rate.phone2" :description="rate.description2" ></el-step>
          <el-step title="网格员" :description="rate.description3" ></el-step>
        </el-steps>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msg: {
        name: sessionStorage.getItem("name"),
        phone: sessionStorage.getItem("mobileid"),
        partyBrach: sessionStorage.getItem("partybrach"),
        adress: "",
        alreadey:false
      },
      select: "",
      options: [
        {
          value: "养老保险退休认证",
          lable: "养老保险退休认证"
        },
        {
          value: "社区医保代缴",
          lable: "社区医保代缴"
        },
        {
          value: "居住证协助申报及办理",
          lable: "居住证协助申报及办理"
        },
        {
          value: "行动不便居民水电费代缴",
          lable: "行动不便居民水电费代缴"
        },
        {
          value: "行动不便居民代办公交卡",
          lable: "行动不便居民代办公交卡"
        }
      ],
      buttons: true,
      rate: {
        active: 1,
        description1: "网格员接单",
        description2: "",
        phone2:"",
        description3: "",
      }
    };
  },
  methods: {
    getMsg() {
      this.axios
        .post("/api/Main/Reseau", { remark: sessionStorage.getItem("token") })
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.buttons = false;
              this.alreadey = true
              this.msg.adress = e.data.msg.submitterAddress;
              this.select = e.data.msg.submitterType;
              let StyleMsg = ['','等待','已接单','已完结']
              this.rate.active = StyleMsg.indexOf(e.data.msg.StyleMsg)
              if(this.rate.active>1){
                this.rate.description2 = '联系人:'+e.data.msg.submitterName,
                this.rate.phone2 = '联系方式:' + e.data.msg.submitterPhone
                if(this.rate.active>2){
                  this.rate.description3 = "已办理完结"
                }
              }
              break;
            case 1:
              break;
            default:
              break;
          }
        });
    },
    submit() {
      if (this.msg.adress != "" && this.select != "") {
        this.axios
          .post("/api/Main/addGrid", {
            submitterName: this.msg.name,
            submitterPhone: this.msg.phone,
            submitterTown: this.msg.partyBrach,
            submitterAddress: this.msg.adress,
            submitterType: this.select,
            remark: sessionStorage.getItem("token")
          })
          .then(e => {
            switch (e.data.code) {
              case 0:
                alert("添加成功");
              this.alreadey = true

                this.getMsg()
                break;
              default:
                alert(e.data.msg);
                break;
            }
          });
      } else {
        alert("请填写地址和选择办理事项");
      }
    }
  },
  mounted() {
    this.getMsg();
  }
};
</script>
<style lang='scss' scoped>
.grid-service {
  .things {
    p{
      margin-bottom: .3rem;
    }
    button {
      padding: 0.2rem 1rem;
      border-radius: 0.08rem;
      border: none;
      color: #fff;
      font-size: 0.3rem;
      background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
    }
    text-align: center;
    margin-top: 0.5rem;
  }
  .select {
    .el-select {
      width: 80%;
    }
    text-align: center;
    padding: 0.3rem 0;
    border-bottom: 0.3rem solid #f9f9f9;
  }
  .self-msg {
    p {
      .el-input {
        width: 80%;
      }
      &:nth-child(5) {
        display: flex;
        align-items: center;
      }
      color: #999999;
      line-height: 3;
      border-bottom: 0.01rem solid #e6e6e6;
    }
    width: 94%;
    margin: 0 auto;
  }
  .banner {
    img {
      width: 94%;
    }
    text-align: center;
  }
  padding-top: 1.2rem;
  font-size: 0.3rem;
  background: #fff;
  min-height: 100vh;
}
</style>
<style lang="scss">
.grid-service {
  .things {
    .el-step__description.is-process,
    .el-step__title.is-process,
    .el-step__phone.is-process {
      color: #C0C4CC;
      font-size: 0.24rem;
      padding: 0;
    }
    .el-step__title.is-wait{
      font-size: 0.24rem;

    }
    .el-step__head.is-process{
      color: #C0C4CC;
      border-color: #C0C4CC;
    }

    .el-step__head.is-finish {
      color: #f9b94d;
      border-color: #ffba00;
    }
    .el-step__phone.is-finish,
    .el-step__description.is-finish,
    .el-step__title.is-finish {
      color: #f9b94d;
      font-size: 0.24rem;
      padding: 0;
    }
  }
  .self-msg {
    p {
      input {
        border: none;
        padding-left: 0.1rem;
      }
    }
  }
}
</style>